import React from "react";
import { useQuery } from "@tanstack/react-query";
import { transactionService } from "../../services/transactions";
import LoadingSpinner from "../Common/LoadingSpinner";

export default function ZReport({ date }) {
  const { data, isLoading } = useQuery({
    queryKey: ["z-report", date],
    queryFn: () => transactionService.getZReport(date)
  });

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold mb-4">Z-Report - {date}</h3>
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-gray-50 p-3 rounded">
          <p className="text-sm">Total Sales</p>
          <p className="text-xl font-bold">KES {data?.summary?.total_sales?.toLocaleString() || 0}</p>
        </div>
        <div className="bg-gray-50 p-3 rounded">
          <p className="text-sm">Cash Sales</p>
          <p className="text-xl font-bold">KES {data?.summary?.cash_sales?.toLocaleString() || 0}</p>
        </div>
        <div className="bg-gray-50 p-3 rounded">
          <p className="text-sm">M-Pesa Sales</p>
          <p className="text-xl font-bold">KES {data?.summary?.mpesa_sales?.toLocaleString() || 0}</p>
        </div>
        <div className="bg-gray-50 p-3 rounded">
          <p className="text-sm">Transactions</p>
          <p className="text-xl font-bold">{data?.summary?.transaction_count || 0}</p>
        </div>
      </div>
    </div>
  );
}